import React from "react";
import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";

const SSideBar = styled.div`
    width: 200px;
    background: #CCCCCC;
    //height: 100%;
    padding: 5px;
    float: left;
    //flex: 50 50 200px; /* Fixed width of 200px for the sidebar */
    //overflow-y: auto; /* Allows sidebar content to scroll if it overflows the viewport height */
    //position: relative;
`;

const SideBarGroup = styled.div`
    padding: 10px 0px 0px 0px;
    font-weight: bold;
`;

const SideBarLink = styled(Link)`
  color: #000000;
  align-items: left;
  text-decoration: none;
  padding: 0 1rem;
  cursor: pointer;
  &:link {
    color: #660000;
  }
  &:visited {
    color: #660000;
  }
  &:active {
    color: #660000;
  }
  &:hover {
    color: #CC7700;
    text-decoration: underline;
  }
`;

const SideBar = () => {
    return (
        <SSideBar>
            <SideBarGroup>testy</SideBarGroup>
            <SideBarLink to="/test">typy testów</SideBarLink><br/>
            <SideBarGroup>język</SideBarGroup>
            <SideBarLink to="/grammar">gramatyka</SideBarLink><br/>
            <SideBarLink to="/idiom">idiomy</SideBarLink><br/>
            <SideBarLink to="/phrase">zwroty</SideBarLink><br/>
            <SideBarLink to="/lang">o języku</SideBarLink><br/>
            <SideBarGroup>zasoby</SideBarGroup>
            <SideBarLink to="/dictionary">słownik</SideBarLink><br/>
            <SideBarLink to="/verb">baza czasowników</SideBarLink><br/>
            <SideBarLink to="/proverb">przysłowia</SideBarLink><br/>
            <SideBarLink to="/template">wzory podań/listów</SideBarLink><br/>
            <SideBarGroup>katalogi</SideBarGroup>
            <SideBarLink to="/www">strony www</SideBarLink><br/>
            <SideBarLink to="/book">książki</SideBarLink><br/>
            <SideBarLink to="/music">muzyka</SideBarLink><br/>
            <SideBarLink to="/poetry">poezja</SideBarLink><br/>
            <SideBarGroup>o EPT</SideBarGroup>
            <SideBarLink to="/about">o serwise</SideBarLink><br/>
            <SideBarLink to="/sitemap">mapa</SideBarLink><br/>
        </SSideBar>
    );
};

export default SideBar;